import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { ErrorBoundary } from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "react-lazy-load-image-component/src/effects/black-and-white.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-lazy-load-image-component/src/effects/opacity.css";
import "react-quill/dist/quill.snow.css";
import { BrowserRouter } from "react-router-dom";

import App from "../src/App";
import { CollapseDrawerProvider } from "./contexts/CollapseDrawerContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import "./index.css";
import "./utils/sentry";

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <HelmetProvider>
            <SettingsProvider>
                <LocalizationProvider dateAdapter={AdapterLuxon}>
                    <CollapseDrawerProvider>
                        <BrowserRouter>
                            <ErrorBoundary fallback={<div>Something went wrong. Please refresh the page.</div>}>
                                <App />
                            </ErrorBoundary>
                        </BrowserRouter>
                    </CollapseDrawerProvider>
                </LocalizationProvider>
            </SettingsProvider>
        </HelmetProvider>
    </StrictMode>
);
